import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const newsPostListState = (state: AppState) => state.contentManagement.newsPost.newsPostList;

export const newsPostListItemsSelector = createSelector(newsPostListState, state => {
    const newsPostItems = state.items;
    return {
        ...newsPostItems,
        items: newsPostItems.items.map(item => ({
            ...item,
            previewImage: item.image['168x72'],
        })),
    };
});
export const newsPostListRequestingSelector = createSelector(newsPostListState, state => state.requesting);
